import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

export const materialProviders = [
  provideNativeDateAdapter(),
  { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: { appearance: 'outline' }
  }
];
